export interface HuskMigCredentials {
    brugernavn: string;
    kodeord: string;
    huskMig: boolean;
}
